import React from "react";

const CourseOutline = () => {
  return <div>CourseOutline</div>;
};

export default CourseOutline;
